import React from 'react';
import { Popup } from 'semantic-ui-react';
import { FiCheckCircle, FiMinusCircle } from 'react-icons/fi';
import { useSelector } from 'react-redux';

import {
    makeSelectVirtualizedTableItemValueAsBoolean,
    makeSelectVirtualizedTableColumnLabel
} from 'services/virtualizedTable/selectors';
import { VirtualizedTableProps } from 'services/virtualizedTable/types';
import { AppState } from 'services/types';

type Props = VirtualizedTableProps;

const VirtualizedTableConfirmationCheckboxIcon = (
    props: Props
): React.ReactElement => {
    const checked = useSelector((state: AppState) =>
        makeSelectVirtualizedTableItemValueAsBoolean()(state, props)
    );

    const label = useSelector((state: AppState) =>
        makeSelectVirtualizedTableColumnLabel()(state, props)
    );

    const notCheckedRender = (
        <Popup
            trigger={
                <FiMinusCircle
                    size={22}
                    className="text grey"
                    style={{ verticalAlign: 'middle', marginLeft: '-3px' }}
                />
            }
            content={`Not ${label}`}
            inverted
            basic
            position="top center"
        />
    );

    const checkedRender = (
        <Popup
            trigger={
                <FiCheckCircle
                    size={22}
                    className="text pink"
                    style={{ verticalAlign: 'middle', marginLeft: '-3px' }}
                />
            }
            content={label}
            inverted
            basic
            position="top center"
        />
    );

    return checked ? checkedRender : notCheckedRender;
};

export default VirtualizedTableConfirmationCheckboxIcon;
